/**
 * Estimated driving distance between two lat/lng points in kilometers.
 *
 * Starts from the great-circle ("hemelsbreed") distance, then applies a 1.3×
 * detour factor to approximate real road distance in Western Europe.
 * An actual Mapbox Directions lookup replaces this at checkout.
 */
export type LatLng = { lat: number; lng: number };

const EARTH_RADIUS_KM = 6371;
/** Road-to-straight-line ratio for Western Europe. */
const ROAD_DETOUR_FACTOR = 1.3;

function toRadians(deg: number): number {
    return (deg * Math.PI) / 180;
}

export function haversineKm(from: LatLng, to: LatLng): number {
    const dLat = toRadians(to.lat - from.lat);
    const dLng = toRadians(to.lng - from.lng);

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRadians(from.lat)) * Math.cos(toRadians(to.lat)) * Math.sin(dLng / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_KM * c * ROAD_DETOUR_FACTOR;
}
